@if (!errorDisplayed) {
  <div class="scrollable-container">
    <div class="mb-2 courrierView me-4 ms-4">
      <div class="courrierView__header mt-1">
        @if (courrier) {
          <div class="row">
            @if (courrier?.writeLock?.contact) {
              <div
                class="col-md-12 alert alert-primary alert-dismissible fade show d-flex align-items-center justify-content-between tac-newalert mb-0"
                [ngClass]="{ 'd-none': hideID === 0 }">
                <div>
                  <span class="mt-1px"><i class="bi bi-pencil me-2"></i>{{ 'courrierFiche.currentlyBeingModified' | translate }}</span>
                  @if (courrier?.writeLock) {
                    <span class="mt-1px">
                      {{ 'courrierFiche.by' | translate }} " {{ courrier?.writeLock?.contact?.nom }}
                      {{ courrier?.writeLock?.contact?.prenom ? courrier?.writeLock?.contact?.prenom : '' }} "
                    </span>
                  }
                </div>
                <i class="bi bi-x-circle-fill mt-1px" style="font-size: 18px" (click)="hideAlert(0)"></i>
              </div>
            }
            @if (courrier?.mauvaisRoutage) {
              <div
                class="col-md-12 alert alert-warning d-flex align-items-center justify-content-between tac-newalert mb-0"
                [ngClass]="{ 'd-none': hideID === 1 }">
                <div>
                  <span class="mt-1px">{{ 'courrierFiche.wrongRouting' | translate }} : {{ courrier?.mauvaisRoutageCommentaires }}</span>
                </div>
                <i class="bi bi-x-circle-fill mt-1px" style="font-size: 18px" (click)="hideAlert(1)"></i>
              </div>
            }
            @if (courrier?.filesToValidate && courrier?.filesToValidate.length > 0) {
              <div
                class="col-md-12 alert alert-primary d-flex align-items-center justify-content-center alert-dismissible fade show tac-newalert mb-0"
                [ngClass]="{ 'd-none': hideID === 2 }">
                <div>
                  <span class="mt-1px">{{ 'courrierFiche.fileToValidate' | translate }} :</span>
                  @for (item of courrier?.filesToValidate; track item) {
                    <span>
                      "{{ item?.description }}"
                      @if (item?.procedureValidationValidationServiceId) {
                        <div class="d-inline-block">
                          &nbsp;{{ 'courrierFiche.forService' | translate }}
                          {{ servicesChildParent | label_by_id: item?.procedureValidationValidationServiceId }}
                        </div>
                      }
                      @if (item?.procedureValidationValidationRoleId) {
                        <div class="d-inline-block">
                          &nbsp;{{ 'courrierFiche.withRole' | translate }} {{ rolesLV | label_by_id: item?.procedureValidationValidationRoleId }}.
                        </div>
                      }
                    </span>
                  }
                </div>
                <i class="bi bi-x-circle-fill mt-1px" style="font-size: 18px" (click)="hideAlert(2)"></i>
              </div>
            }
            @if (courrier?.filesToSign?.length > 0) {
              <div class="col-md-12 alert alert-primary alert-dismissible fade show tac-newalert mb-0" [ngClass]="{ 'd-none': hideID === 3 }">
                {{ 'courrierFiche.fileToSign' | translate }} :
                @for (item of courrier?.filesToSign; track item) {
                  <span>
                    {{ item?.description }}
                    @if (item?.procedureValidationSignatureServiceId) {
                      <div class="d-inline-block">
                        , {{ 'courrierFiche.forService' | translate }}
                        {{ servicesChildParent | label_by_id: item?.procedureValidationSignatureServiceId }}
                      </div>
                    }
                    @if (item?.procedureValidationSignatureRoleId) {
                      <div class="d-inline-block">
                        &nbsp;{{ 'courrierFiche.withRole' | translate }} {{ rolesLV | label_by_id: item?.procedureValidationSignatureRoleId }}.
                      </div>
                    }
                  </span>
                }
                <i class="bi bi-x-circle alert-close" (click)="hideAlert(3)"></i>
              </div>
            }
            @if (courrier?.avalider) {
              <div class="col-md-12 alert alert-warning alert-dismissible fade show tac-newalert mb-0" [ngClass]="{ 'd-none': hideID === 4 }">
                {{ 'courrierFiche.currentlyNotValidated' | translate }}
                @if (courrier?.validationEtapeMax && courrier?.validationUsers) {
                  <span class="d-block">
                    {{ currentStepValidationTranslation(courrier?.validationEtape, courrier?.validationEtapeMax, courrier?.validationUsers) }}
                  </span>
                }
                <i class="bi bi-x-circle alert-close" (click)="hideAlert(4)"></i>
              </div>
            }
            @if (courrier?.aCompleter) {
              <div class="col-md-12 alert alert-warning alert-dismissible fade show tac-newalert mb-0" [ngClass]="{ 'd-none': hideID === 6 }">
                {{ 'courrierFiche.mailNotCompleted' | translate }}
                <i class="bi bi-x-circle alert-close" (click)="hideAlert(6)"></i>
              </div>
            }
            @if (courrier?.supprime) {
              <div class="col-md-12 alert alert-danger alert-dismissible fade show tac-newalert mb-0" [ngClass]="{ 'd-none': hideID === 7 }">
                {{ 'courrierFiche.mailDeleted' | translate }}
                <i class="bi bi-x-circle alert-close" (click)="hideAlert(7)"></i>
              </div>
            }
          </div>
        }
      </div>
      <div class="d-flex w-100 mb-2 align-items-center justify-content-between pb-3 super-compos-sectionseparator-horizontal">
        <section class="pb-3 w-100">
          <div id="list{{ courrierTitle?.id }}" class="object__col">
            @if (courrierTitle) {
              <div class="object__body">
                <div class="object__header">
                  <div class="object__header--left">
                    @if (courrierTitle?.icon) {
                      <span [innerHtml]="courrierTitle?.icon" class="me-1"></span>
                    }
                    <span class="object__user">{{ courrierTitle.expGroup }}</span>
                  </div>
                  @if (courrierTitle?.statusGlobalName) {
                    <div
                      class="object__status"
                      [style.color]="courrierTitle?.statusGlobalBackground"
                      ng-style="{ 'border-right': courrierTitle?.statusGlobalBackground }"
                      style="border-right: 2px solid">
                      {{ courrierTitle?.statusGlobalName }}
                    </div>
                  }
                </div>
                <div>
                  <div class="object__middle">
                    <div class="object__title">
                      <span>{{ courrierTitle.title }}</span>
                    </div>
                    @if (
                      courrier.workflowForInfos?.definitionVersion?.name &&
                      courrier.workflowForInfos.subStatus &&
                      courrier.workflowForInfos.subStatus !== 'Cancelled' &&
                      courrier.workflowForInfos.subStatus !== 'Finished'
                    ) {
                      <div>
                        @if (courrier.workflowForInfos.hasFaultedState) {
                          <span>{{ courrier.workflowForInfos.definitionVersion.name }} <i class="bi bi-circle-fill ms-1 icon--red"></i></span>
                        } @else {
                          <span
                            >{{ courrier.workflowForInfos.definitionVersion.name }}
                            <i
                              class="bi bi-circle-fill ms-1"
                              [ngClass]="{
                                'icon--red': courrier.workflowForInfos.subStatus === 'Faulted',
                                'icon--orange':
                                  courrier.workflowForInfos.subStatus === 'Pending' ||
                                  courrier.workflowForInfos.subStatus === 'Executing' ||
                                  courrier.workflowForInfos.subStatus === 'Suspended',
                              }"></i
                          ></span>
                        }
                      </div>
                    }
                  </div>
                  <div class="object__bottom">
                    <div class="object__category">
                      <div class="d-flex">
                        @if (courrierTitle?.id || courrierTitle?.idString) {
                          <span class="me-2 idContainer fs-16">{{ courrierTitle.idString ? courrierTitle.idString : courrierTitle.id }}</span>
                        }
                        @if (courrierTitle?.countLinks) {
                          <div class="object__links d-flex align-items-center me-2">
                            <i class="bi bi-link-45deg fs_1-25 me-1"></i>{{ courrierTitle?.countLinks }}
                          </div>
                        }
                        @if (courrierTitle?.natureId) {
                          <div class="object__links d-flex align-items-center me-2" style="font-size: 13px; margin-bottom: -4px">
                            <i class="bi bi-envelope me-1"></i>{{ courrierTitle?.nature.description }}
                          </div>
                        }
                        @if (tagsCourrier.length > 0) {
                          <div class="object__links object__links__tags d-flex align-items-center me-2" style="font-size: 13px; margin-bottom: -4px">
                            <img src="./assets/img/infos_tag.svg" width="10" height="10" class="img-fluid me-1 mb-1" alt="" />
                            @for (tag of tagsCourrier; track tag; let i = $index) {
                              <span>
                                <span class="tagsContainer mb-1" [ngClass]="{ 'me-2': i < tagsCourrier.length - 1 }" [style.color]="tag.textColor">{{
                                  tag.description
                                }}</span>
                              </span>
                            }
                          </div>
                        }
                      </div>
                      <div>
                        @if (courrierTitle?.confidentiel === true) {
                          <div
                            class="object__confidential iconPrivate me-2"
                            pTooltip="Ce courrier est confidentiel et son accès est restreint aux seules personnes ayant les droits">
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              style="enable-background: new 0 0 512 512"
                              xml:space="preserve">
                              <path
                                style="fill: #303c42"
                                d="M437.333,192h-32v-42.667C405.333,66.99,338.344,0,256,0S106.667,66.99,106.667,149.333V192h-32
                                                C68.771,192,64,196.771,64,202.667v266.667C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333V202.667
                                                C448,196.771,443.229,192,437.333,192z M341.333,192H170.667v-42.667C170.667,102.281,208.948,64,256,64
                                                s85.333,38.281,85.333,85.333V192z" />
                              <path
                                style="fill: #f2f2f2"
                                d="M128,149.333c0-70.583,57.417-128,128-128s128,57.417,128,128V192h-21.333v-42.667
                                                c0-58.813-47.854-106.667-106.667-106.667S149.333,90.521,149.333,149.333V192H128V149.333z" />
                              <path
                                style="fill: #ffca28"
                                d="M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333
                                                v-256h341.333V469.333z" />
                              <path
                                style="opacity: 0.2; fill: #ffffff; enable-background: new"
                                d="M128,469.333v-256H85.333v256
                                                c0,11.76,9.573,21.333,21.333,21.333H144C135.18,490.667,128,481.094,128,469.333z" />
                              <path
                                style="opacity: 0.1; enable-background: new"
                                d="M384,213.333v256c0,11.76-7.18,21.333-16,21.333h37.333
                                                c11.76,0,21.333-9.573,21.333-21.333v-256H384z" />
                              <path
                                style="fill: #303c42"
                                d="M230.792,354.313l-6.729,60.51c-0.333,3.01,0.635,6.031,2.656,8.292
                                                c2.021,2.26,4.917,3.552,7.948,3.552h42.667c3.031,0,5.927-1.292,7.948-3.552c2.021-2.26,2.99-5.281,2.656-8.292l-6.729-60.51
                                                c10.927-7.948,17.458-20.521,17.458-34.313c0-23.531-19.135-42.667-42.667-42.667S213.333,296.469,213.333,320
                                                C213.333,333.792,219.865,346.365,230.792,354.313z" />
                              <path
                                style="fill: #5c6671"
                                d="M256,298.667c11.76,0,21.333,9.573,21.333,21.333c0,8.177-4.646,15.5-12.125,19.125
                                                c-4.073,1.979-6.458,6.292-5.958,10.781l6.167,55.427h-18.833l6.167-55.427c0.5-4.49-1.885-8.802-5.958-10.781
                                                c-7.479-3.625-12.125-10.948-12.125-19.125C234.667,308.24,244.24,298.667,256,298.667z" />
                              <path
                                style="opacity: 0.1; enable-background: new"
                                d="M247.716,340.001c-1.434-2.866-2.383-5.987-2.383-9.335
                                                c0-11.76,9.573-21.333,21.333-21.333c3.12,0,6.034,0.749,8.708,1.958c-3.349-7.406-10.734-12.625-19.375-12.625
                                                c-11.76,0-21.333,9.573-21.333,21.333c0,8.177,4.646,15.5,12.125,19.125C247.193,339.32,247.349,339.763,247.716,340.001z" />
                              <path
                                style="opacity: 0.1; enable-background: new"
                                d="M261.927,373.965l-2.48-22.288c-0.701-0.608-1.125-1.466-1.988-1.885
                                                c-2.096-1.016-3.9-2.376-5.512-3.911c0.385,1.323,0.962,2.599,0.803,4.026l-6.167,55.427h11.853L261.927,373.965z" />
                              <linearGradient
                                id="SVGID_1_"
                                gradientUnits="userSpaceOnUse"
                                x1="-43.622"
                                y1="637.2695"
                                x2="-23.8368"
                                y2="628.0435"
                                gradientTransform="matrix(21.3333 0 0 -21.3333 996.3334 13791.667)">
                                <stop offset="0" style="stop-color: #ffffff; stop-opacity: 0.2" />
                                <stop offset="1" style="stop-color: #ffffff; stop-opacity: 0" />
                              </linearGradient>
                              <path
                                style="fill: url(#SVGID_1_)"
                                d="M437.333,192h-32v-42.667C405.333,66.99,338.344,0,256,0S106.667,66.99,106.667,149.333V192
                                            h-32C68.771,192,64,196.771,64,202.667v266.667C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333
                                            V202.667C448,196.771,443.229,192,437.333,192z M341.333,192H170.667v-42.667C170.667,102.281,208.948,64,256,64
                                            s85.333,38.281,85.333,85.333V192z" />
                            </svg>
                          </div>
                        }
                      </div>
                    </div>
                    <div>
                      <span class="object__date"> {{ courrierTitle.date }} </span>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- END DIV OBJECT__BODY-->
            <!-- END COL-MD12-->
          </div>
        </section>
        <section>
          <div class="courrierView__header__menuR actionsNotPDL">
            <!-- ! flex-direction: row-reverse; a ne pas enlever! Parce que le css ne fonctionne que pour un élément après, pas avant => on a reverse afin que l'élément à gauche soit, dans le DOM, a droite (ca sert pour enlever la border shadow :D ) -->
            <div class="d-flex justify-content-center" style="flex-direction: row-reverse">
              <div
                class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 actionClass d-flex flex-column justify-content-start"
                (click)="actionModal = true">
                <img src="./assets/img/actions.svg" width="20" height="20" class="img-fluid mb-2" alt="" />
                <p class="mb-0">{{ 'courrierFiche.actions' | translate }}</p>
              </div>
              @if (rightMail?.edit) {
                <div
                  class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 modifierClass d-flex flex-column justify-content-start"
                  (click)="editCourrier(courrier)">
                  <img src="./assets/img/modifier.svg" width="20" height="20" class="img-fluid mb-2" alt="" />
                  <p class="mb-0">{{ 'courrierFiche.edit' | translate }}</p>
                </div>
              }
              @if (rightMail?.answerMail) {
                <div
                  class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 repondreClass d-flex flex-column justify-content-start"
                  (click)="openCreateModal()">
                  <img src="./assets/img/repondre.svg" width="25" height="25" class="img-fluid mb-2" style="margin-top: 4px" alt="" />
                  <p class="mb-0">{{ 'courrierFiche.reply' | translate }}</p>
                </div>
              }
            </div>
          </div>
          <div class="courrierView__header__menuR d-none actionsPDL">
            <!-- ! flex-direction: row-reverse; a ne pas enlever! Parce que le css ne fonctionne que pour un élément après, pas avant => on a reverse afin que l'élément à gauche soit, dans le DOM, a droite (ca sert pour enlever la border shadow :D ) -->
            <div class="d-flex justify-content-center" style="flex-direction: row-reverse; height: 100%">
              <div
                class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 actionClass d-flex flex-column justify-content-start"
                (click)="actionModal = true">
                <img src="./assets/img/actions_pdl.svg" width="20" height="20" class="img-fluid mb-2" alt="" />
                <p class="mb-0">{{ 'courrierFiche.actions' | translate }}</p>
              </div>
              @if (rightMail?.edit) {
                <div
                  class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 modifierClass d-flex flex-column justify-content-start"
                  (click)="editCourrier(courrier)">
                  <img src="./assets/img/modifier_pdl.svg" width="20" height="20" class="img-fluid mb-2" alt="" />
                  <p class="mb-0">{{ 'courrierFiche.edit' | translate }}</p>
                </div>
              }
              <div
                class="boldFont cursor--pointer alignImgTxt ps-3 pe-3 pt-3 pb-3 repondreClass d-flex flex-column justify-content-start"
                (click)="openCreateModal()">
                <img src="./assets/img/repondre_pdl.svg" width="25" height="25" class="img-fluid mb-2" style="margin-top: 4px" alt="" />
                <p class="mb-0">{{ 'courrierFiche.reply' | translate }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="courrierView__tabs mt-1">
        <i-tabs-xl-v2
          [tabs]="tabsArrayXL"
          [currentTabId]="mailTabActiveXL"
          (onSelectTab)="receive_tabsXL($event)"
          (currentTabIdChange)="changeCurrentTabId($event)"></i-tabs-xl-v2>
      </div>
    </div>
    <div class="me-4 ms-4">
      @switch (mailTabActiveXL) {
        @case ('infos') {
          <div class="general-infos__display">
            <app-courrier-details-general-infos
              [courrier]="courrier"
              [sourceList]="sourceList"
              [natureList]="natureList"
              [configuration]="configuration"
              [tags]="tags"
              [tagsCourrier]="tagsCourrier"
              [rightFlux]="rightFlux"
              [rightMail]="rightMail"
              [rightManagement]="rightManagement"
              [userServices]="userServices"
              [servicesChildParent]="servicesChildParent"
              [groupsMemberUserConnected]="groupsMemberUserConnected"
              (openiBacEmitter)="openIbacSidebar()"
              (addTagsEmitter)="addTags($event)"
              (deleteTagsEmitter)="deleteTags($event)"
              (createTagEmitter)="createTag()"
              (cancelWorkflowInstanceEmitter)="cancelFlow()"
              (deleteWorkflowInstanceEmitter)="deleteFlow()"
              (resumeWorkflowInstanceEmitter)="resumeFlow()"
              (retryFaultedWorkflowInstanceEmitter)="retryFaultedFlow()"></app-courrier-details-general-infos>
            <div style="height: 5vh"></div>
          </div>
        }
        @case ('files') {
          <div (dragover)="$event.preventDefault()" (drop)="onNativeDrop($event)">
            <i-dragndrop [droppableAreas]="droppableAreas()">
              <p-splitter [panelSizes]="panelSize" [style]="{ height: '100%' }">
                <ng-template pTemplate>
                  <div class="d-flex justify-content-between me-3" style="margin-left: 0px !important">
                    <div class="fiche-point-content-info__title mb-2">{{ 'courrierFiche.linkedFiles' | translate }}</div>
                    <div class="cursor--pointer">
                      <a class="fiche-point-content-info__title d-flex align-items-center downloadAllButton" (click)="collapse('left')">
                        <svg
                          width="14.0962432px"
                          height="14px"
                          viewBox="0 0 14.0962432 14"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Medium-Copy-28" transform="translate(-694, -216.0251)">
                              <g
                                id="Group-8"
                                transform="translate(701.0481, 223.0251) scale(-1, 1) translate(-701.0481, -223.0251)translate(694, 216.0251)">
                                <rect id="Rectangle" fill="#60CDFF" x="10.1547032" y="1.54040438" width="2.33998482" height="10.9199292"></rect>
                                <polygon
                                  id="Path-8"
                                  stroke="#60CDFF"
                                  stroke-width="1.5"
                                  stroke-linejoin="round"
                                  points="0 0 14.0962432 0 14.0962432 14 0 14"></polygon>
                                <polyline
                                  id="Path-9"
                                  stroke="#60CDFF"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  points="1.89409197 7 8.79370226 7 5.34389712 10.497306"></polyline>
                                <line
                                  x1="8.79370226"
                                  y1="7"
                                  x2="5.34389712"
                                  y2="3.52328383"
                                  id="Path-10"
                                  stroke="#60CDFF"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"></line>
                              </g>
                            </g>
                          </g>
                        </svg>
                        &nbsp; {{ 'courrierFiche.hideFiles' | translate }}</a
                      >
                    </div>
                  </div>
                  <app-courrier-create-add-files
                    [forceSwitchFile]="forceSwitchFile"
                    [courrier]="courrier"
                    [contactId]="userInfos?.contactId"
                    [uploadedFilesFromDragAndDrop]="uploadedFilesFromDragAndDrop"
                    [rightMailInfo]="rightMail"
                    (currentFile)="receiveCurrentFile($event)"
                    (currentAmountFile)="receiveAmountOfFiles($event)"
                    keysConfirm="courrierFicheForm"
                    (mailModeEvent)="receiveMailMode($event)"
                    (reloadAfterValidationOrSignatureOfFile)="handleValidationAndSignature()"
                    (uploadedFilesAreSaved)="receiveUploadedFilesAreSaved()">
                  </app-courrier-create-add-files>
                </ng-template>
                <ng-template pTemplate>
                  <div class="ms-2">
                    <div class="cursor--pointer">
                      @if (collapsedState === 'left') {
                        <a class="fiche-point-content-info__title downloadAllButton d-flex align-items-center" (click)="collapse('middle')">
                          <svg
                            width="14.0962432px"
                            height="14px"
                            viewBox="0 0 14.0962432 14"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="Medium-Copy-29" transform="translate(-530, -201.0251)">
                                <g
                                  id="Group-8"
                                  transform="translate(537.0481, 208.0251) scale(-1, 1) translate(-537.0481, -208.0251)translate(530, 201.0251)">
                                  <g id="Group" transform="translate(7.0481, 7) scale(-1, 1) translate(-7.0481, -7)">
                                    <rect id="Rectangle" fill="#60CDFF" x="1.5" y="1.54040438" width="2.33998482" height="10.9199292"></rect>
                                    <polygon
                                      id="Path-8"
                                      stroke="#60CDFF"
                                      stroke-width="1.5"
                                      stroke-linejoin="round"
                                      points="0 0 14.0962432 0 14.0962432 14 0 14"></polygon>
                                    <g
                                      id="Group-3"
                                      transform="translate(4.8941, 3.5233)"
                                      stroke="#60CDFF"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5">
                                      <polyline id="Path-9" points="0 3.47671617 6.89961029 3.47671617 3.44980514 6.97402212"></polyline>
                                      <line x1="6.89961029" y1="3.47671617" x2="3.44980514" y2="-6.26762911e-17" id="Path-10"></line>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          &nbsp; {{ 'courrierFiche.showFiles' | translate }}</a
                        >
                      }
                    </div>
                    @if (fileToShow) {
                      <div
                        class="w-100 d-flex justify-content-between align-items-center"
                        style="position: sticky; top: 0; background-color: #fff; z-index: 10">
                        <div class="w-100">
                          <div class="w-100 d-flex justify-content-between">
                            <span class="fileViewer__Title"> {{ fileToShow?.description }}</span>
                            <div>
                              @if (amountOfFiles > 1) {
                                <div class="d-flex flex-row">
                                  <i-button
                                    size="small"
                                    id="btnArrowLeftFiles"
                                    icon="bi bi-arrow-left"
                                    styleClass="blue doubleBtnLeft me-1"
                                    (click)="switchFile(-1)"></i-button>
                                  <i-button
                                    size="small"
                                    id="btnArrowRightFiles"
                                    icon="bi bi-arrow-right"
                                    styleClass="blue doubleBtnRight"
                                    (click)="switchFile(+1)"></i-button>
                                </div>
                              }
                            </div>
                          </div>

                          <div class="w-100 d-flex justify-content-between align-items-center">
                            <span class="fileViewer__infos mb-0">Source : {{ fileToShow?.editeurSourceType }}</span>
                            <span class="fileViewer__infos mb-0"
                              >{{ 'courrierFiche.updatedOn' | translate }} {{ fileToShow?.dateUpload | momentFormat: 'DD/MM/YYYY à HH:mm' }}</span
                            >
                          </div>
                          @if (listOfVersion?.length > 1) {
                            <div class="w-100 d-flex justify-content-between align-items-center">
                              <div class="cursor--pointer">
                                <span class="fileViewer__infos">{{ 'version' | translate }} {{ fileToShow?.version }} - </span>
                                <span class="fileViewer__infos" (click)="op.toggle($event)">
                                  {{ fileToShow?.label }} <b><i class="bi bi-caret-down-square"></i></b
                                ></span>
                                <p-overlayPanel #op appendTo="body">
                                  <ng-template pTemplate>
                                    @for (a of listOfVersion; track a; let i = $index) {
                                      <span class="ms-2 me-2 dropdown-element" (click)="changeVersion(a, op)"
                                        >{{ 'version' | translate }} {{ a.version }} - {{ a.label }}</span
                                      >
                                    }
                                  </ng-template>
                                </p-overlayPanel>
                              </div>
                              @if (isAnotherVersionThanVersionOfFile) {
                                <i-button
                                  size="small"
                                  id="btnArrowLeftFiles"
                                  text="Restaurer cette version"
                                  styleClass="blue doubleBtnLeft me-1"
                                  (click)="restoreVersion()"></i-button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (!fileToShow) {
                      <div class="nofound">
                        <img src="./assets/img/decoration/nofiles.svg " class="img-fluid" width="600" alt="" />
                      </div>
                    }
                    <hr class="my-3" />
                    @if (rightMail?.files?.open && fileToShow) {
                      <app-courrier-file-viewer
                        [setHeightforExcelTable]="'60vh'"
                        [currentFiles]="fileToShow"
                        class="d-block font-source"></app-courrier-file-viewer>
                    }
                  </div>
                </ng-template>
              </p-splitter>
            </i-dragndrop>
          </div>
        }
        @case ('recipients') {
          <div>
            <app-courrier-create-recipients
              [listToReloadDatas]="listToReloadDatas"
              [courrier]="courrier"
              [services]="servicesChildParent"
              [rightMail]="rightMail"
              (recipients)="receiveDestinataire($event)">
            </app-courrier-create-recipients>
          </div>
        }
        @case ('links') {
          <div class="formActive">
            <app-courrier-lien
              [displayTitle]="false"
              [mailActive]="courrier"
              (linkCountEvent)="receive_linkCount($event)"
              dialogId="courrierFicheForm"></app-courrier-lien>
          </div>
        }
        @case ('historic') {
          <div class="Historique">
            <app-courrier-fiche-history [mailId]="courrier && courrier.id"></app-courrier-fiche-history>
          </div>
        }
      }
    </div>
  </div>
}
@if (errorDisplayed) {
  <div class="d-flex flex-column align-items-center justify-content-center" style="min-height: 60vh; gap: 1rem">
    <i class="bi bi-shield-lock text-danger" style="font-size: 4rem; opacity: 0.7"></i>
    <p class="text-muted text-center mb-0" style="max-width: 400px">{{ errorDisplayed }}</p>
  </div>
}

<p-confirmDialog
  key="courrierFicheForm"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

@if (openMauvaisRoutage) {
  <p-dialog
    [(visible)]="openMauvaisRoutage"
    [modal]="true"
    appendTo="body"
    [style]="{ width: '50vw' }"
    styleClass="super-compos-modal-content modal-scss"
    [closable]="true">
    <p-header>
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.wrongRoutingTitle' | translate }}</h5>
      </div>
    </p-header>
    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-primary">{{ 'courrierFiche.resendToService' | translate }} : {{ mauvais_routage?.description }} ?</div>
      </div>
      @if (courrier?.workflowId) {
        <div class="col-md-12">
          <div class="alert alert-danger">
            <i class="bi bi-exclamation-triangle-fill icon--orange"></i> {{ 'courrierFiche.existingFlowWillBeStopped' | translate }}
            <i class="bi bi-exclamation-triangle-fill icon--orange"></i>
          </div>
        </div>
      }
      <div class="col-md-12 mb-3" [formGroup]="formMauvaisRoutage">
        <textarea
          rows="5"
          cols="30"
          [placeholder]="'insertCommentHere' | translate"
          formControlName="commentaires"
          class="super-compos-input-text form-control w-100"
          pInputTextarea></textarea>
          <div class="input-warning mt-1">{{ '(mandatoryField)' | translate }}</div>
      </div>
      <div class="col-md-12 d-flex justify-content-end">
        <i-button styleClass="red me-2" (click)="openMauvaisRoutage = false" text="Annuler"></i-button>
        <i-button styleClass="green"(click)="putBadRoutage()" text="Confirmer" [disabled]="formMauvaisRoutage.invalid"></i-button>
      </div>
    </div>
  </p-dialog>
}

<p-sidebar [(visible)]="openSidebarIBac" position="right" styleClass="p-sidebar-md">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <i-title [text]="'moveToBin' | translate"></i-title>
      </div>
      <div class="col-md-12 mt-4">
        <span><i class="bi bi-info-circle-fill"></i> {{ 'courrierFiche.moveMailToBinForFlow' | translate }}</span>
      </div>
      @for (bac of bacs; track bac) {
        <div class="col-md-12 mt-3" (click)="moveToBac(bac)">
          @if (bac?.nePasUtilise === false && bac?.transfertManuel === true) {
            <div class="ibacCard">
              <div class="ibacCard__content">
                <img src="./assets/img/drawer.svg" width="35" class="img-fluid me-3" alt="" />
                <div>
                  <h3 class="ibacCard__title">{{ bac?.name }} ({{ bac?.typeDisplay }})</h3>
                  <span class="ibacCard__text" pTooltip="{{ bac?.description }}" tooltipPosition="bottom">
                    {{ bac?.description | maxLength: 50 }}
                  </span>
                </div>
              </div>
              <i class="bi bi-arrow-90deg-right iconBlue ibacCard__action"></i>
            </div>
          }
        </div>
      }
    </div>
  </div>
</p-sidebar>

<p-confirmDialog
  key="moveToBacConfirm"
  #md
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle"
  baseZIndex="99999">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="md.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="md.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-dialog [(visible)]="actionModal" [modal]="true" appendTo="body" header="Actions" [style]="{ width: '30vw' }">
  @if (
    rightMail?.prendreEnChargeExclusive ||
    rightMail?.prendreEnChargeCollaborative ||
    rightMail?.refuserPriseEnCharge ||
    rightMail?.annulerPriseEnCharge
  ) {
    <section>
      @if (
        rightMail?.prendreEnChargeExclusive ||
        rightMail?.prendreEnChargeCollaborative ||
        rightMail?.refuserPriseEnCharge ||
        rightMail?.annulerPriseEnCharge
      ) {
        <div class="fiche-point-content-info__title mb-2 text-uppercase">
          {{ 'courrierFiche.handling' | translate }}
        </div>
      }
      @if (rightMail?.prendreEnChargeExclusive) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="prendreEnChargeExclusive()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_charge_exclusive.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.exclusiveHandling' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.prendreEnChargeCollaborative) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="prendreEnChargeCollective()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_charge_collaborative.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            Je {{ 'courrierFiche.collaborativeHandling' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.refuserPriseEnCharge) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="refusePrendreEnCharge()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_charge_refuser.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.refuseHandling' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.annulerPriseEnCharge) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="cancelPrendreEnCharge()">
          <div class="mb-2 cursor--pointer">
            <img src="./assets/img/actions_annuler_prise_en_charge.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.cancelHandling' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
    </section>
  }
  @if (rightMail?.distribution?.addUser || configuration?.isSmtpConfigured || rightsDelibe) {
    <section>
      <div
        class="fiche-point-content-info__title mb-2 text-uppercase"
        [ngClass]="{
          'mt-4':
            rightMail?.prendreEnChargeExclusive ||
            rightMail?.prendreEnChargeCollaborative ||
            rightMail?.refuserPriseEnCharge ||
            rightMail?.annulerPriseEnCharge,
        }">
        {{ 'courrierFiche.mailTracking' | translate }}
      </div>
      @if (rightMail?.distribution?.addUser) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="createAction()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_suivi_demander_action.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.requestAction' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.distribution?.addUser) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="transfer()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_suivi_envoyer_info.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.sendForInfo' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightsDelibe) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openPointInIdelibe()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_creer_point_delibe.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.createPointInIDelibe' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (configuration?.isSmtpConfigured) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openAssistant()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_assistant_mail.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.mailAssistant' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
    </section>
  }
  @if (rightMail?.pin || rightMail?.markAPrendreEnCharge || rightMail?.mauvaisRoutageMail) {
    <section>
      <div class="fiche-point-content-info__title mb-2 text-uppercase mt-4">{{ 'courrierFiche.mailMarking' | translate }}</div>
      @if (rightMail?.pin) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="pin(courrier)">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_marquage_epingler.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            @if (courrier?.pinned === true) {
              <span>{{ 'courrierFiche.unpinned' | translate }}</span>
            }
            @if (courrier?.pinned === false) {
              <span>{{ 'courrierFiche.pinned' | translate }}</span>
            }
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.markAPrendreEnCharge) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openPrendreEnCharge()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_a_prendre_en_charge.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.toBeHandled' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.mauvaisRoutageMail) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openBadRoutage()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_marquage_mauvais_routage.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.wrongRouting' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
    </section>
  }
  @if (rightMail) {
    <section>
      @if (rightMail) {
        <div
          class="fiche-point-content-info__title mb-2 text-uppercase"
          [ngClass]="{ 'mt-4': rightMail?.pin || rightMail?.markAPrendreEnCharge || rightMail?.mauvaisRoutageMail }">
          {{ 'courrierFiche.mailManagement' | translate }}
        </div>
      }
      @if (rightMail?.validate && courrier?.avalider) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="validate()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_valider_courrier.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.validateMail' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.canMoveToBac && rightMail?.edit) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openIbacSidebar()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_gestion_bac.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.moveToBin' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightFlux?.canStartWorkflowManually && rightMail?.edit) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="startFlowManually()">
          <div class="mb-0 cursor--pointer">
            <i class="bi bi-play-circle"></i>
            {{ 'courrierFiche.launchFlow' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }

      @if (rightMail) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="openDuplicate()">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_gestion_dupliquer.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.duplicate' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.canDeleteMail) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="deleteCourrier(courrier, true)">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/action_gestion_delete.svg" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.delete' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
      @if (rightMail?.canDeleteMail && courrier.supprime === true) {
        <div class="d-flex justify-content-between actions-menu-item ms-0 me-1" (click)="deleteCourrier(courrier, false)">
          <div class="mb-0 cursor--pointer">
            <img src="./assets/img/actions_reactiver.svg" width="22" height="22" class="img-fluid me-2" alt="" />
            {{ 'courrierFiche.reactivate' | translate }}
          </div>
          <svg
            width="13.4997799px"
            height="11px"
            viewBox="0 0 13.4997799 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.434175037">
              <g id="Medium-Copy-8" transform="translate(-907.162570, -188.000000)" fill="#000000" fill-rule="nonzero">
                <g id="noun-arrow-2286327" transform="translate(513.000000, 179.000000)">
                  <path
                    d="M394.162745,14.500169 C394.16972,14.678913 394.243311,14.8855585 394.365904,15.0158342 L398.865864,19.7657927 C399.128661,20.0770712 399.634027,20.07079 399.929426,19.7902068 C400.224835,19.5096199 400.249075,19.0129814 399.951748,18.7345017 L396.654812,15.2501125 L406.912312,15.2501125 C407.326473,15.2501125 407.66235,14.9142493 407.66235,14.5000744 C407.66235,14.0858994 407.326487,13.7500363 406.912312,13.7500363 L396.654812,13.7500363 L399.951748,10.2656471 C400.249075,9.98715397 400.22466,9.48824315 399.929252,9.20766525 C399.633844,8.92707841 399.121134,8.92585967 398.86569,9.23434626 L394.365729,13.9843048 C394.228837,14.129741 394.164664,14.2994181 394.16257,14.4999699 L394.162745,14.500169 Z"
                    id="Path"
                    transform="translate(400.912460, 14.500000) scale(-1, 1) translate(-400.912460, -14.500000) "></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      }
    </section>
  }
</p-dialog>
